import { render } from "./moskitohelden.vue?vue&type=template&id=c2230f04"
import script from "./moskitohelden.vue?vue&type=script&lang=js"
export * from "./moskitohelden.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__